// extracted by mini-css-extract-plugin
module.exports = {"modal":"PhotoAlbums-modal-1ffAx","imgPreview":"PhotoAlbums-imgPreview-2RF1S","content":"PhotoAlbums-content-1y8sO"};